<template>
  <div>
    <gljy-select v-if="slotSetting.type == 'gljySelect'" 
      :value="slotSetting.selectSetting.multiple ? value?.split(','):value" 
      :type="slotSetting.selectSetting.type" :queryFunction="slotSetting.selectSetting.queryFunction"
      :dataSource="slotSetting.selectSetting.dataSource" :fieldNames="slotSetting.selectSetting.fieldNames"
      :extendQueryWhere="slotSetting.selectSetting.extendQueryWhere" :multiple="slotSetting.selectSetting.multiple"
      :model="slotSetting.selectSetting.model">
    </gljy-select>
    <div v-if="slotSetting.type == 'function' || slotSetting.type == 'functionStr'">{{ customFunction() }}</div>
  </div>
</template>

<script>
import { ref, reactive, toRefs } from 'vue'
export default {
  props: {
    value: {
      type: [String, Object, Number, undefined]
    },
    record: {
      type: Object,
      default: () => {
        return {}
      }
    },
    /**
     * type: 插槽组件类型 hsSelect 和 function 和 functionStr
     */
    slotSetting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  setup(props, context) {
    const datas = reactive({

    })

    const methods = {
      customFunction() {
        try {
          if (props.slotSetting.type == 'functionStr') {
            // 得到对应的函数信息
            const functionStr = props.slotSetting.function;
            let fun = eval(`(${functionStr})`);
            return fun(props.value)
          } else {
            return props.slotSetting.function(props.value, props.record)
          }
        } catch (e) {
          console.error("table自定义插槽配置函数错误", e)
        }
      }
    }

    return {
      ...toRefs(datas),
      ...methods
    }
  }
}
</script>

<style></style>